module.exports = __webpack_public_path__ + "static/img/banner.0b4c1664.png";